import styled from 'styled-components'

export const StyledH1 = styled.h1`
    display: flex;
    column-gap: 20px;
    justify-content: start;
    flex-direction: row;
    background: #eeeeee;
    color: #003366;
    padding: 20px;
    margin: 0px; 
    font-size: 24px;
    font-weight: 600;
`

export const StyledH2 = styled.h2`
    display: flex;
    column-gap: 20px;
    justify-content: space-between;
    flex-direction: row;
    background: #003366;
    color: white;
    padding: 8px;
    margin: 0px;
    font-size: 22px;
`

export const StyledConfigHeader = styled.h2`
    display: flex;
    column-gap: 20px;
    justify-content: space-between;
    flex-direction: row;
    font-weight: 600;
    color: #003366;
    padding: 25px;
    margin: 0px;
    font-size: 22px;
`

export const StyledSVG = styled.svg`
    height: 50px;
    margin-right: 20px;              
`